import { EVALUATION_STATES } from "../../Constants/evaluation";
export var FilterInitialState = {
  make: '',
  price: '',
  body_type: '',
  year: '',
  emi: ''
};
var initialState = {
  filters: FilterInitialState,
  currentStep: 1,
  evaluationState: EVALUATION_STATES.INITIAL,
  carCount: 0
};
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case 'UPDATE_BUYER_INTENT_FILTER':
      return Object.assign(Object.assign({}, state), {
        filters: Object.assign(Object.assign({}, state.filters), action.data)
      });
    case 'UPDATE_BUYER_INTENT_EVAL_STATE':
      return Object.assign(Object.assign({}, state), {
        evaluationState: action.data
      });
    case 'UPDATE_CAR_COUNT':
      return Object.assign(Object.assign({}, state), {
        carCount: action.data
      });
    default:
      return state;
  }
});